import firebase from "firebase";
const firebaseConfig = {
    apiKey: "AIzaSyCwzfMjTKI54m6m1L_M-zdTULmwuE2P8ys",
    authDomain: "nept-mocktest.firebaseapp.com",
    databaseURL: "https://nept-mocktest-default-rtdb.firebaseio.com",
    projectId: "nept-mocktest",
    storageBucket: "nept-mocktest.appspot.com",
    messagingSenderId: "935677560096",
    appId: "1:935677560096:web:7a333632a9355bf9274345",
    measurementId: "G-RFS8FN3G2N"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);


export const db = firebaseApp.firestore();